// extracted by mini-css-extract-plugin
export var button = "_fs-0";
export var donut = "_fs-1";
export var donutFill = "_fs-3";
export var donutTrack = "_fs-2";